import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function useScrollToTopOnNavigationChange() {
  const location = useLocation();

  useEffect(() => {
    // Scroll to the top of the page whenever the URL's path changes
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null; // This hook does not need to return anything
}
